import { render, staticRenderFns } from "./nursePresAddXz.vue?vue&type=template&id=49735522&scoped=true"
import script from "./nursePresAddXz.vue?vue&type=script&lang=ts"
export * from "./nursePresAddXz.vue?vue&type=script&lang=ts"
import style0 from "./nursePresAddXz.vue?vue&type=style&index=0&id=49735522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49735522",
  null
  
)

export default component.exports